<template>
  <div class="pr-2 pl-2 mt-5">
    <div class="vx-row">
      <div class="vx-col sm:w-full w-full md:w-12/12">
        <div
          class="vx-row"
        >
          <div class="vx-col md:w-1/3 sm:w-full w-full">
            <report-statistics-item-card
              class="mb-5 queue-status-report-item"
              :title="$t('total_incoming_call')"
              :is-loading="isLoading"
              :display="queueDetails.totalIncomingCalls"
            />
          </div>

          <div class="vx-col md:w-1/3 sm:w-full w-full">
            <report-statistics-item-card
              class="mb-5 queue-status-report-item answer-call"
              :title="$t('answer_call')"
              :is-loading="isLoading"
              :display="queueDetails.answeredCalls"
            />
          </div>

          <div class="vx-col md:w-1/3 sm:w-full w-full">
            <report-statistics-item-card
              class="mb-5 queue-status-report-item abandonment"
              :title="$t('abandonment_issue')"
              :is-loading="isLoading"
              :display="queueDetails.droppedCalls"
            />
          </div>
        </div>
        <div
          class="vx-row"
        >
          <div class="vx-col md:w-1/2 sm:w-full w-full">
            <report-statistics-item-card
              class="mb-5 queue-status-report-item"
              :title="$t('response_rate')"
              :display="`${queueDetails.asf}%`"
              :is-loading="isLoading"
            />
          </div>
          <div class="vx-col md:w-1/2 sm:w-full w-full">
            <report-statistics-item-card
              class="mb-5 queue-status-report-item"
              :title="$t('call_pending')"
              :display="queueDetails.totalCalls"
              :is-loading="isLoading"
            />
          </div>
        </div>
        <div
          class="vx-row"
        >
          <div class="vx-col md:w-1/2 sm:w-full w-full">
            <report-statistics-item-card
              class="mb-5 queue-status-report-item"
              :title="$t('estimated_wait_time')"
              :display="queueDetails.holdTime"
              :is-loading="isLoading"
            />
          </div>
          <div class="vx-col md:w-1/2 sm:w-full w-full">
            <report-statistics-item-card
              class="mb-5 queue-status-report-item"
              :title="$t('average_talk_time')"
              :display="queueDetails.talkTime"
              :is-loading="isLoading"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReportStatisticsItemCard from '@/components/cards/ReportStatisticsItemCard'
import Node from '@/models/Node'

import io from 'socket.io-client'

export default {
  name: 'Window.Queues.Status.Report',
  components: {
    ReportStatisticsItemCard
  },
  data () {
    return {
      socket: {},
      server: {},
      queueStatusNode: {},
      queueDetails: {
        answeredCalls: 0, // callsAnswered
        droppedCalls: 0, // callsAbandoned
        asf: 0,
        tsf: 0,
        slt: 0,

        strategy: '',
        totalCalls: 0, // noofcalls
        holdTime: '00:00:00', // expectedWaitTime
        notAnswered: 0,

        talkTime: 0,
        totalIncomingCalls: 0 // callsoffered
      },
      cacheExt: {},
      isLoading: true,
      testExtension: 1
    }
  },
  computed: {
    queue () {
      return this.$route.query.queue
    }
  },
  async mounted () {

    document.title = this.$t('queues')

    const response = await Node.getServerAndNodeByLoggedInUser()
    this.server = response.data.server
    this.queueStatusNode = response.data.server.queue_status

    this.socket = io.connect(`${this.queueStatusNode.domain}:${this.queueStatusNode.port}/${this.queueStatusNode.pivot.namespace}`, { query: { queueno: this.queue }, transports: ['websocket'] })
    this.socket.on('connect', this.getInitialExtensions)
    this.socket.on('message', this.getMessage)

  },
  methods: {
    getInitialExtensions () {
      this.socket.emit('get-initial-extensions')
    },
    getMessage (data) {
      if (data.api_type === 'queue') {
        this.manageQueueDetails(data)
      }
      this.isLoading = false
    },
    manageQueueDetails (data) {
      const tempAsf = (this.queueDetails.answeredCalls * 100 / (this.queueDetails.answeredCalls + this.queueDetails.droppedCalls))
      const tempTsf = (this.queueDetails.answeredCalls * parseFloat(data.service_level) / (this.queueDetails.answeredCalls + this.queueDetails.droppedCalls))

      this.queueDetails.answeredCalls = (isNaN(data.calls_answered) || data.calls_answered == '') ? 0 : parseInt(data.calls_answered)
      this.queueDetails.droppedCalls = (isNaN(data.calls_notanswered) || data.calls_notanswered == '') ? 0 : parseInt(data.calls_notanswered)
      this.queueDetails.asf = (isNaN(tempAsf) || tempAsf == '') ? '0.00' : tempAsf.toFixed(2)
      this.queueDetails.tsf = (isNaN(tempTsf) || tempTsf == '') ? '0.00' : tempTsf.toFixed(2)
      this.queueDetails.slt = '';
      if(data.service_level != '') {
        this.queueDetails.slt = data.service_level.split('within')[1].trim().replace('s', '')
      }

      this.queueDetails.strategy = data.strategy
      this.queueDetails.totalCalls = (isNaN(data.noofcalls) || data.noofcalls == '') ? 0 : parseInt(data.noofcalls)
      this.queueDetails.holdTime = (data.holdtime == '') ? '00:00:00' : data.holdtime
      this.queueDetails.talkTime = (data.talktime == '') ? '00:00:00' : data.talktime
      this.queueDetails.totalIncomingCalls = this.queueDetails.answeredCalls + this.queueDetails.droppedCalls
    }
  }
}
</script>

<style lang="scss">
.queue-status-report-item div:nth-child(1) {
  background-color: #115377;
}
.queue-status-report-item div:nth-child(1) h4 {
  color: #fff !important;
  font-size: 2em;
}
.queue-status-report-item div:nth-child(2) {
  color: #115377;
  font-size: 2.5em;
  font-weight: bold;
  background-color: #fff;
}
.queue-status-report-item div.vx-card__body {
  padding: 20px 15px !important
}
.queue-status-report-item.answer-call div:nth-child(1) {
  background-color: lightgreen;
}
.queue-status-report-item.answer-call div:nth-child(1) h4 {
  color: green !important;
  font-size: 2em;
}
.queue-status-report-item.answer-call div:nth-child(2) {
  color: green;
}
.queue-status-report-item.abandonment div:nth-child(1) {
  background-color: #b481e7;
}
.queue-status-report-item.abandonment div:nth-child(1) h4 {
  color: purple !important;
  font-size: 2em;
}
.queue-status-report-item.abandonment div:nth-child(2) {
  color: purple;
}
</style>
